/* eslint-disable camelcase */
import { CONFIGS } from "../configs";
import { API } from "./API";
import { getApiUrl } from "../utils/platform";

export const getC3DInfos = (query) => {
  var {
    currentPage = 1,
    itemsPerPage = 20,
    sortBy = 'created_at',
    sortOrder = -1,
    search = '',
    ...filterParams
  } = query;

  console.log("[Debug] TKT1 C3D Info query", query);

  const page = parseInt(currentPage) || 1;
  const limit = parseInt(itemsPerPage) || 20;
  const skip = (page - 1) * limit;

  let sort = {};
  const order = parseInt(sortOrder) || -1;
  sort[sortBy] = order;

  let queryString = `currentPage=${page}&itemsPerPage=${limit}&sortBy=${sortBy}&sortOrder=${order}`;

  if (search && search.trim()) {
    queryString += `&search=${encodeURIComponent(search.trim())}`;
  }

  // Add other filter parameters
  Object.keys(filterParams).forEach(key => {
    const value = filterParams[key];
    if (value !== undefined && value !== null && value !== '') {
      queryString += `&${key}=${encodeURIComponent(value)}`;
    }
  });

  return API.get(`${getApiUrl()}/api/tkt1-c3d-info/get?${queryString}`);
};

export const getC3DInfoByID = (id) => {
  return API.get(`${getApiUrl()}/api/tkt1-c3d-info/get/${id}`);
};

export const createC3DInfo = (c3dInfoData) => {
  return API.post(`${getApiUrl()}/api/tkt1-c3d-info/create`, c3dInfoData);
};

export const updateC3DInfo = (id, c3dInfoData) => {
  return API.put(`${getApiUrl()}/api/tkt1-c3d-info/update/${id}`, c3dInfoData);
};

export const deleteC3DInfo = (id) => {
  return API.delete(`${getApiUrl()}/api/tkt1-c3d-info/delete/${id}`);
};

export const tkt1C3DInfoService = {
  getC3DInfos,
  getC3DInfoByID,
  createC3DInfo,
  updateC3DInfo,
  deleteC3DInfo
};
